import { MenuItemProps, useNotificationCount, useTranslationLang, useTranslationRoute, useTranslations } from "@bsm/component";
import { useMemo } from "react";

export const useLeftSideBarMenuGeneral = () => {

    const [
        TRANSLATION,
        GENERAL,
        CALENDAR,
        NOTIFICATIONS,
    ] = useTranslations(i18n)
    const { lang } = useTranslationLang()
    const translationRoute = useTranslationRoute();
    const notificationCount = useNotificationCount()

    return useMemo((): MenuItemProps => ({
        ke: "general",
        label: GENERAL,
        className: "menu-item-category",
        items: [
            process.env.REACT_APP_ENV === 'development' ? {
                label: TRANSLATION,
                link: translationRoute("admin/translation"),
                startIcon: "fa-solid fa-language",
            } : undefined,
            {
                label: CALENDAR,
                link: translationRoute("admin/project/calendar"),
                startIcon: "fa-solid fa-calendar-days",
            },
            {
                label: NOTIFICATIONS,
                link: translationRoute("admin/notification"),
                startIcon: "fa-solid fa-bell",
                badge: notificationCount > 0 ? notificationCount : undefined
            },
        ],
    }), [notificationCount, lang])
}

const i18n = [
    'BSMRH.Admin.LeftSideBar.Menu.General.Translation.Label',
    'BSMRH.Admin.LeftSideBar.Menu.General.Label',
    'BSMRH.Admin.LeftSideBar.Menu.General.Calendar.Label',
    'BSMRH.Admin.LeftSideBar.Menu.General.Notifications.Label',
]
